let dragSrcEl: HTMLElement;

/**
 * This function controls the drag start event listener.
 * 
 * @param {object} e event object
 */
export function handleDragStart(e: any) { 
  e.target.style.opacity = '0.4';      

  dragSrcEl = e.target;

  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('elementid', e.target.innerHTML);
}

/**
 * This function controls the drop event listener.
 * 
 * @param {object} e event object
 */
export function handleDrop(e: any) {
  e.stopPropagation();

  if (dragSrcEl !== e.target) {
    dragSrcEl.innerHTML = e.target.innerHTML;
    e.target.innerHTML = e.dataTransfer.getData('elementid');

    let span = document.querySelectorAll<HTMLElement>('.title');
    if ( !span ) return;
    span.forEach((item: any, index: number) => item.setAttribute('data-sequence', index + 1));
  }
}

/**
 * Function to handle adding CSS class to element
 * 
 * @param {object} e event object
 */
export function handleDragEnter(e: any) {
  e.target.classList.add('over');   
}

/**
 * Function to handle removing CSS class from element
 * 
 * @param {object} e event object
 */
export function handleDragLeave(e: any) {
  if ( e.target.classList.contains('over') ) {
    e.target.classList.remove('over');
  }      
}

/**
 * Function to prevent page refresh
 */
export function handleDragOver(e: any) {
  e.preventDefault();
  return false;
}

/**
 * Function to handle returning default styles to all elements after drag is finished
 * 
 * @param {object} e event object
 */
export function handleDragEnd(e: any) {
  e.target.style.opacity = '1';

  let items = document.querySelectorAll('.askfor-widget');
  if ( !items ) return;
  items.forEach((item: any) => {
    item.classList.remove('over');
  });
}